import { Trans } from '@lingui/react'
import { func, number, shape, string } from 'prop-types'
import { Component } from 'react'
import { connectRange } from 'react-instantsearch-dom'

import { PRODUCT_FILTER_RESET_SFX } from 'shared/experiments/components/NewSerp/consts'
import store, { subscribe } from 'shared/store'
import {
  hideModalAction,
  PRODUCT_FILTER_RESET,
} from 'shared/store/ducks/events'
import Button from 'views/components/atoms/Button'
import StarRatingSlider from 'views/components/molecules/StarRatingSlider'
import {
  getRealMaxForRatings,
  getRealMinForRatings,
} from 'views/components/organisms/AlgoliaInstantSearch/Algolia/helpers'
import { AVERAGE_RATING_DEFAULT_VALUES } from 'views/components/organisms/AlgoliaInstantSearch/ProductFilter/consts'

class ProductFilterV1StarRatingSliderInner extends Component {
  constructor(props) {
    super(props)

    const { minValue, maxValue } = props.defaultValues

    this.state = {
      values: [minValue, maxValue],
      currentRefinement: props.currentRefinement,
      refine: props.refine,
    }
  }

  componentDidMount() {
    const { minValue, maxValue } = this.props.defaultValues
    const { attribute } = this.props

    subscribe.after(PRODUCT_FILTER_RESET, () => {
      this.setState({
        values: [minValue, maxValue],
      })
    })

    if (attribute) {
      subscribe.after(`${PRODUCT_FILTER_RESET_SFX}${attribute}`, () => {
        this.setState({
          values: [minValue, maxValue],
        })
      })
    }
  }

  update({ min, max }) {
    const { refine } = this.state

    refine({
      min: getRealMinForRatings(min),
      max: getRealMaxForRatings(max),
    })
  }

  onValuesUpdated = ({ values: [min, max] }) => {
    this.setState({ values: [min, max] })
  }

  onApplyFiltersClick = () => {
    const {
      currentRefinement,
      values: [min, max],
    } = this.state

    if (currentRefinement.min !== min || currentRefinement.max !== max) {
      this.update({ min, max })
    }

    store.dispatch(hideModalAction(this.props.modalId))
  }

  onStarClick = (value, isMin) => {
    const {
      currentRefinement,
      values: [min, max],
    } = this.state

    let newMin = isMin ? value : min
    let newMax = !isMin ? value : max

    if (isMin && value > max) {
      newMax = value
    }

    if (!isMin && value < min) {
      newMin = value
    }

    if (currentRefinement.min !== newMin || currentRefinement.max !== newMax) {
      this.setState({ values: [newMin, newMax] })
    }
  }

  render() {
    const { label, attribute, currentRefinement, ...starRatingSliderProps } =
      this.props
    const { values } = this.state

    const isModified =
      values[0] !== currentRefinement.min || values[1] !== currentRefinement.max

    return (
      <div className="o-star-rating-slider-v1">
        <div className="u-font-weight--semi-bold u-margin-small--bottom">
          {label}
        </div>
        <StarRatingSlider
          {...starRatingSliderProps}
          min={AVERAGE_RATING_DEFAULT_VALUES.min}
          max={AVERAGE_RATING_DEFAULT_VALUES.max}
          values={values}
          onValuesUpdated={this.onValuesUpdated}
          onStarClick={this.onStarClick}
        />
        <Button
          onClick={this.onApplyFiltersClick}
          name={`refinement-list-confirm-selection-${attribute}`}
          className="o-star-rating-slider-v1__cta"
          isClientsideControlled
        >
          {isModified ? (
            <Trans id="general.label.link.apply" />
          ) : (
            <Trans id="general.link.label.back" />
          )}
        </Button>
      </div>
    )
  }
}

ProductFilterV1StarRatingSliderInner.propTypes = {
  ...StarRatingSlider.propTypes,
  label: string.isRequired,
  attribute: string.isRequired,
  currentRefinement: shape({}).isRequired,
  refine: func.isRequired,
  defaultValues: shape({
    minValue: number,
    maxValue: number,
  }),
  modalId: string,
}

ProductFilterV1StarRatingSliderInner.defaultProps = {
  ...StarRatingSlider.defaultProps,
  defaultValues: {
    minValue: AVERAGE_RATING_DEFAULT_VALUES.min,
    maxValue: AVERAGE_RATING_DEFAULT_VALUES.max,
  },
}

export const ProductFilterV1StarRatingSlider = connectRange(
  ProductFilterV1StarRatingSliderInner
)
